import { Box, Typography } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import React, { useState } from 'react'
import AdxButton from 'components/custom/AdxButton'

const NewFormNotification = ({ title }) => {
  const [isModalOpen, setModalOpen] = useState(true)

  const handleClose = () => {
    setModalOpen(false)
  }

  return (
    <AdxFormModal
      title={'Reminder'}
      subtitle={''}
      open={isModalOpen}
      onClose={handleClose}
      handleClose={handleClose}
      sxModal={{ width: 550 }}
      disableAutoFocus={true}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="body1">
            1. Only <b>linear scales</b> will be counted for quantitative measurement
          </Typography>
          <Typography variant="body1">
            2. Other options will be available to be viewed by the reviewee as final result.
          </Typography>
        </Box>

        <AdxButton sx={{ width: 1 }} onClick={handleClose}>
          Continue
        </AdxButton>
      </Box>
    </AdxFormModal>
  )
}

export default NewFormNotification
